import styled from 'styled-components'

const Section = styled.section`
  width: 100%;
  height: 400px;
  margin-top: 5vh;
  margin-bottom: 5vh;
`
export default Section
